"use client";

import { FC } from "react";
import cx from "classnames";
import { Vehicle } from "../../../types/vehicle";
import { WebWorkerActionBututton } from "../../../types/action-buttons";
import ActiveEngageButton from "./buttons/activeEngageChat";
import ActionButtonCommon from "./actionButtonCommon";
import AutofiCalculatePaymentButton from "./buttons/autofiCalculatePayment";

export interface ActionButtonPrefetchedData {
  prefetchedValue: any;
  actionButtonData: WebWorkerActionBututton;
}

interface IActionButton {
  actionButton: WebWorkerActionBututton;
  currentVehicle: Vehicle;
  prfetchedData: any;
  className?: string;
  vehicleDataChanged: () => void;
  layoutType: "list" | "detail";
}

const ActionButton: FC<IActionButton> = (props) => {
  switch (props.actionButton.buttonConfigName) {
    case "activengage-chat": {
      return (
        <div className={props.className}>
          <ActiveEngageButton {...props.actionButton.actionButtonData}></ActiveEngageButton>
        </div>
      );
    }
    case "auto-fi-calculate-payment": {
      return (
        <div className={cx(props.className, "autofi-container")}>
          <AutofiCalculatePaymentButton
            {...props.actionButton.actionButtonData}
            VIN={props.currentVehicle.vin || ""}
            layoutType={props.layoutType}
          ></AutofiCalculatePaymentButton>
        </div>
      );
    }
    default: {
      return <ActionButtonCommon {...props} />;
    }
  }
};

export default ActionButton;
